// Spinner — loading indicator per COMPONENTS §Catalog.
//
// Decorative by default (`aria-hidden`); caller wraps in role="status"
// aria-live="polite" + sr-only text when standing alone (page-level loading).
// Uses currentColor so the caller controls the color with a text-* class.

export interface SpinnerProps {
  /** Diameter in px. Default 24 — meets WCAG min target visually. */
  size?: number;
  className?: string;
}

export function Spinner({ size = 24, className = '' }: SpinnerProps) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={`animate-spin ${className}`}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
